import { Component, OnInit, inject } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { APP_TOAST_KEY, ToastContentComponent, ToastModule } from '@pflegix/ui';
import { FilterMatchMode } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingStore } from '../../loading.store';
import { AppSidebarsContainerComponent } from '../../shared/components/app-sidebars-container/app-sidebars-container.component.component';

@Component({
  selector: 'pfx-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, ToastModule, ToastContentComponent, ProgressSpinnerModule, AppSidebarsContainerComponent],
  providers: [LoadingStore],
})
export default class AppComponent implements OnInit {
  private readonly primeConfig = inject(PrimeNG);

  protected readonly APP_TOAST_KEY = APP_TOAST_KEY;

  protected loadingStore = inject(LoadingStore);

  public ngOnInit(): void {
    // TODO move to config service
    this.primeConfig.filterMatchModeOptions = {
      text: [FilterMatchMode.STARTS_WITH, FilterMatchMode.CONTAINS, FilterMatchMode.EQUALS],
      numeric: [
        FilterMatchMode.EQUALS,
        FilterMatchMode.LESS_THAN,
        FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        FilterMatchMode.GREATER_THAN,
        FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
      ],
      date: [
        FilterMatchMode.DATE_IS,
        FilterMatchMode.DATE_IS_NOT,
        FilterMatchMode.DATE_BEFORE,
        FilterMatchMode.DATE_AFTER,
      ],
    };
  }
}
